import axios from './axios';
import config from '../../helpers/config';

export default (designId, itemId, newName) => (
  axios.post(
    `${config.designBuilderLoadDesignPath}/${designId}/items/${itemId}/copy`,
    { Name: newName },
  )
);
